export const StarIndicator = () => (<span className="text-danger small pl-1">*</span>)
